var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-theme",
    { attrs: { "md-name": "white-brown" } },
    [
      _c(
        "md-toolbar",
        { staticClass: "toolbar" },
        [
          _c(
            "router-link",
            { staticClass: "md-title", attrs: { to: { name: "Marketplace" } } },
            [
              _c("img", {
                staticClass: "rhebus-logo",
                attrs: { src: require("../assets/img/RhebusTV_logo.jpg") }
              })
            ]
          ),
          _c("span", { staticStyle: { flex: "1" } }),
          _c(
            "div",
            { staticClass: "compact-button" },
            [
              _c(
                "router-link",
                { attrs: { to: { name: "Marketplace" } } },
                [
                  _c(
                    "md-button",
                    [
                      _c("md-icon", {
                        staticClass: "on-left",
                        attrs: { "md-iconset": "fa fa-film" }
                      }),
                      _c("span", { staticClass: "hiddenText" }, [
                        _vm._v("Find Videos")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "router-link",
                { attrs: { to: { name: "CreateDistribution" } } },
                [
                  _c(
                    "md-button",
                    [
                      _c("md-icon", {
                        staticClass: "on-left",
                        attrs: { "md-iconset": "fa fa-share-square" }
                      }),
                      _c("span", { staticClass: "hiddenText" }, [
                        _vm._v("Distribute Content")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "md-menu",
            {
              ref: "reportingMenu",
              staticClass: "compact-button",
              attrs: {
                "md-align-trigger": "md-align-trigger",
                "md-direction": "bottom left",
                "md-size": "4"
              }
            },
            [
              _c(
                "md-button",
                { attrs: { "md-menu-trigger": "" } },
                [
                  _c("md-icon", {
                    staticClass: "on-left",
                    attrs: { "md-iconset": "fa fa-chart-bar" }
                  }),
                  _c("span", { staticClass: "hiddenText" }, [
                    _vm._v("Reporting")
                  ])
                ],
                1
              ),
              _c(
                "md-menu-content",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.reportingMenuClicked.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "Reports" } } },
                        [
                          _c("md-icon", {
                            staticClass: "on-left",
                            attrs: { "md-iconset": "fa fa-chart-line" }
                          }),
                          _c("span", [_vm._v("Views")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "Domains" } } },
                        [
                          _c("md-icon", {
                            staticClass: "on-left",
                            attrs: { "md-iconset": "fa fa-building" }
                          }),
                          _c("span", [_vm._v("Domains")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "Licensing" } } },
                        [
                          _c("md-icon", {
                            staticClass: "on-left",
                            attrs: { "md-iconset": "fa fa-file-contract" }
                          }),
                          _c("span", [_vm._v("Licensing")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.isSuperAdmin()
                    ? _c(
                        "md-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "FinancialSummary" } } },
                            [
                              _c("md-icon", {
                                attrs: { "md-iconset": "fa fa-file-invoice" }
                              }),
                              _c("span", [_vm._v("Platform Billing")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "md-menu",
            {
              ref: "mainMenu",
              staticClass: "compact-button",
              attrs: {
                "md-align-trigger": "md-align-trigger",
                "md-direction": "bottom left",
                "md-size": "4"
              }
            },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-icon-button",
                  attrs: { "md-menu-trigger": "", id: "hamburger" }
                },
                [_c("md-icon", { attrs: { "md-iconset": "fa fa-bars" } })],
                1
              ),
              _c(
                "md-menu-content",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.mainMenuClicked.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "DistributionList" } } },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-share-square" }
                          }),
                          _c("span", [_vm._v("Distributions")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "DomainList" } } },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-building" }
                          }),
                          _c("span", [_vm._v("Domains")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "Videos" } } },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-file-video" }
                          }),
                          _c("span", [_vm._v("Videos")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "VideoSources" } } },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-rss" }
                          }),
                          _c("span", [_vm._v("Video Sources")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "Playlists" } } },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-stream" }
                          }),
                          _c("span", [_vm._v("Playlists")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "Series" } } },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-film" }
                          }),
                          _c("span", [_vm._v("Series")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "LicenseList" } } },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-user-lock" }
                          }),
                          _c("span", [_vm._v("Licenses")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "UserLogsList" } } },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-address-card" }
                          }),
                          _c("span", [_vm._v("User Activity")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "md-menu",
            {
              ref: "userMenu",
              staticClass: "user-menu",
              attrs: {
                "md-align-trigger": "md-align-trigger",
                "md-direction": "bottom left",
                "md-size": "4"
              }
            },
            [
              _c(
                "md-button",
                { attrs: { "md-menu-trigger": "" } },
                [
                  _c("md-avatar", { staticClass: "user-avatar" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.siteuser.picture,
                        alt: _vm.siteuser.nickname
                      }
                    })
                  ]),
                  _c("span", { staticClass: "md-hide-xsmall" }, [
                    _c("span", { staticClass: "username italic" }, [
                      _vm._v(_vm._s(_vm.siteuser.user_metadata.name))
                    ]),
                    _c("sub", { staticClass: "hiddenText italic" }, [
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.isAdmin()
                              ? " ADMIN"
                              : _vm.isAccountAdmin()
                              ? " ACCOUNT ADMIN"
                              : ""
                          )
                        )
                      ])
                    ])
                  ])
                ],
                1
              ),
              _c(
                "md-menu-content",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.userMenuClicked.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "EditUser",
                              params: {
                                id: encodeURIComponent(_vm.siteuser.user_id)
                              }
                            },
                            exact: true
                          }
                        },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-user-circle" }
                          }),
                          _c("span", [_vm._v("My Profile")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.isAdmin()
                    ? _c(
                        "md-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "AccountList" } } },
                            [
                              _c("md-icon", {
                                attrs: { "md-iconset": "fa fa-users-cog" }
                              }),
                              _c("span", [_vm._v("Accounts")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isAdmin()
                    ? _c(
                        "md-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "Impersonate" } } },
                            [
                              _c("md-icon", {
                                attrs: { "md-iconset": "fa fa-user-ninja" }
                              }),
                              _c("span", [_vm._v("Impersonate")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isAccountAdmin()
                    ? _c(
                        "md-menu-item",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "EditAccount",
                                  params: {
                                    id: this.siteuser.user_metadata.account_id
                                  }
                                }
                              }
                            },
                            [
                              _c("md-icon", {
                                attrs: { "md-iconset": "fa fa-users-cog" }
                              }),
                              _c("span", [_vm._v("Account")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isAdmin() || _vm.isAccountAdmin()
                    ? _c(
                        "md-menu-item",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: { to: { name: "UserList" }, exact: true }
                            },
                            [
                              _c("md-icon", {
                                attrs: { "md-iconset": "fa fa-users" }
                              }),
                              _c("span", [_vm._v("Users")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "md-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "PartnerIntegration" } } },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-puzzle-piece" }
                          }),
                          _c("span", [_vm._v("Partner Integrations")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.logout()
                        }
                      }
                    },
                    [
                      _c("md-icon", {
                        attrs: { "md-iconset": "fa fa-sign-out-alt" }
                      }),
                      _c("span", [_vm._v("Sign Out")])
                    ],
                    1
                  ),
                  _c("p", { staticClass: "version-number" }, [
                    _vm._v(_vm._s(_vm.versionNumber))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d06e541", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d06e541","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/Toolbar.vue
// module id = 630
// module chunks = 0